import { useFormContext } from "react-hook-form";
import { WORKFLOW_STATUS } from "../constants";

export const useIsWorkflowInDraftMode = (): boolean => {
  const { getValues } = useFormContext();
  const status = getValues("status");

  return status === WORKFLOW_STATUS.DRAFT;
};
